import { get } from './api';

/**
 * Review r25 robustez (M3): a chave `['/financeiro/categorias', 'lista']` servia duas consultas diferentes. O Contas buscava
 * só a 1ª página (200) e o Financeiro seguia o cursor até o fim; quem chegava primeiro enchia o cache do outro. Com mais de
 * 200 categorias (receitas antes), o formulário de conta a pagar ficava sem nenhuma despesa e o Plano de contas, aberto
 * depois na mesma aba, mostrava 0 despesas por 30 s. Agora a chave tem UMA consulta, a árvore inteira, usada pelos dois.
 */
export const CHAVE_CATEGORIAS_FINANCEIRO = ['/financeiro/categorias', 'lista'] as const;

/**
 * A árvore precisa estar inteira para montar caminhos e filhas. Arremates do review (B6, D18 / R27-ROB-O5): um pedido só
 * (`arvore=true`, até 10.000 categorias; acima disso vem `proximo_cursor` e a tela mostra o aviso de corte), em vez de seguir
 * o cursor em até 50 pedidos de 200 em sequência.
 */
function todasAsCategorias() {
  return get<{ itens: unknown[]; proximo_cursor: string | null }>('/financeiro/categorias', { arvore: true });
}

/** Opções da consulta do plano de contas inteiro (`useQuery(opcoesCategoriasFinanceiro<Categoria>())`). */
export function opcoesCategoriasFinanceiro<T>() {
  return {
    queryKey: CHAVE_CATEGORIAS_FINANCEIRO,
    queryFn: todasAsCategorias as () => Promise<{ itens: T[]; proximo_cursor: string | null }>,
    staleTime: 30_000,
  };
}
